<head>
    <title></title>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
        crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<app-breadcrumb id="MainActivity" *ngIf="(message.showComplaintSwitch && !raiseComplaintData)"></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="cc-form-container" *ngIf="!raiseComplaintData">

    <div class="position-relative grid-content" style="margin-top: 10px;" *ngIf="message.showComplaintSwitch">
        <div>
            <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center px-3">
                    <div class="dropdown">
                    </div>
                </div>
                <div class="d-flex gap-3">
                    <ng-container *ngIf="visibleComplaintGrid; else grid">
                        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                            (click)="switchView()" (keydown.enter)="switchView()">
                            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px"
                                alt="add new" />
                            <span class="reload_text text-white">Raise Complaint</span>
                        </div>
                    </ng-container>
                    <ng-template #grid>
                        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                            (click)="switchView()" (keydown.enter)="switchView()">
                            <img src="../../../assets/img/cr_module/grid.svg" width="18px" height="18px"
                                alt="add new" />
                            <span class="reload_text text-white">My Complaint(s)</span>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!visibleComplaintGrid">
        <div [ngStyle]="!message.showComplaintSwitch? {'':''}: {'margin':'0px 20px'}">
            <fieldset class="border p-2 fieldsetStyle">
                <legend class="float-none w-auto p-2">
                    <span class="" style="font-size: 14px;color: #cfcfcf;">Complainant / Reporter Details</span>
                </legend>
                <div class="row" *ngIf="dynamicLabel">
                    <div class="col-md-3">
                        <div>
                            <!-- Complaint Group -->
                            <label id="group-validation" for="email">Complaint Group</label>
                            <span class="mandatory-symbol">*</span>
                        </div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="selectedCcGroup"
                            (closed)="groupSearchText=''" (click)="focusSearch('focus-group-search')"
                            (keydown.enter)="focusSearch('focus-group-search')"
                            [disabled]="freezeComplaintGroupDropDown">
                            <input type="search" id="focus-group-search" class="dropdownsearchstyle"
                                [(ngModel)]="groupSearchText" matInput placeholder="search">
                            <mat-option class="unselectStyle" [value]="null"
                                (onSelectionChange)="onCcGroupSelect($event,null);">Un-select</mat-option>
                            <mat-option *ngFor="let item of ccGroupDropDown | assessmentSearch : groupSearchText"
                                (onSelectionChange)="onCcGroupSelect($event,item)" [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-md-3" [hidden]="dynamicLabel['REPORTER_TITLE'].isRemovable == 'Y'">
                        <div>
                            <!-- Title -->
                            <label id="title-validation" for="title">
                                {{dynamicLabel['REPORTER_TITLE'].fieldName}}
                            </label> <span class="mandatory-symbol">*</span>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_TITLE'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_TITLE'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReporterTitle"
                            (closed)="titleSearchText=''" (click)="focusSearch('focus-title-search')"
                            (keydown.enter)="focusSearch('focus-title-search')">
                            <input type="search" id="focus-title-search" class="dropdownsearchstyle"
                                [(ngModel)]="titleSearchText" matInput placeholder="search">
                            <mat-option class="unselectStyle" [value]="null"
                                (onSelectionChange)="onReporterTitleSelect($event,null);">Un-select</mat-option>
                            <mat-option *ngFor="let item of reporterTitleDropDown | assessmentSearch : titleSearchText"
                                (onSelectionChange)="onReporterTitleSelect($event,item)" [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-md-3">
                        <div>
                            <!-- First Name -->
                            <label id="firstname-validation" for="first-name">
                                {{dynamicLabel['REPORTER_FIRST_NAME'].fieldName}}
                            </label> <span class="mandatory-symbol">*</span>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_FIRST_NAME'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_FIRST_NAME'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <input class="input-filed-continers" type="text" [(ngModel)]="ccData.reporterFirstName"
                            (ngModelChange)="onNgModuleChange($event,'firstname-validation')">
                    </div>
                    <div class="col-md-3" [hidden]="dynamicLabel['REPORTER_MIDDLE_NAME'].isRemovable == 'Y'">
                        <div>
                            <!-- Middle Name -->
                            <label for="middle-name">{{dynamicLabel['REPORTER_MIDDLE_NAME'].fieldName}}</label>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_MIDDLE_NAME'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_MIDDLE_NAME'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <input class="input-filed-continers" type="text" [(ngModel)]="ccData.reporterMiddleName">
                    </div>
                    <div class="col-md-3" *ngIf="dynamicLabel['REPORTER_LAST_NAME'].isRemovable != 'Y'">
                        <div>
                            <!-- Last Name -->
                            <label id="lastname-validation" for="last-name">
                                {{dynamicLabel['REPORTER_LAST_NAME'].fieldName}}
                            </label> <span class="mandatory-symbol">*</span>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_LAST_NAME'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_LAST_NAME'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <input id="last-name" class="input-filed-continers" type="text"
                            [(ngModel)]="ccData.reporterLastName"
                            (ngModelChange)="onNgModuleChange($event,'lastname-validation')">
                    </div>
                    <div class="col-md-3" [hidden]="dynamicLabel['REPORTER_TYPE'].isRemovable == 'Y'">
                        <div>
                            <!-- Reporter Type -->
                            <label id="reporter-type-validation" for="reporter-type">
                                {{dynamicLabel['REPORTER_TYPE'].fieldName}}
                            </label> <span class="mandatory-symbol">*</span>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_TYPE'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_TYPE'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReporterType"
                            (closed)="reporterTypeSearchText=''" (click)="focusSearch('focus-reporter-type-search')"
                            (keydown.enter)="focusSearch('focus-reporter-type-search')">
                            <input type="search" id="focus-reporter-type-search" class="dropdownsearchstyle"
                                [(ngModel)]="reporterTypeSearchText" matInput placeholder="search">
                            <mat-option class="unselectStyle" [value]="null"
                                (onSelectionChange)="onReporterTypeSelect($event,null);">Un-select</mat-option>
                            <mat-option
                                *ngFor="let item of reporterTypeDropDown | assessmentSearch : reporterTypeSearchText"
                                (onSelectionChange)="onReporterTypeSelect($event,item)" [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-md-3" [hidden]="dynamicLabel['REPORTER_DESIGNATION'].isRemovable == 'Y'">
                        <div>
                            <!-- Reporter Designation -->
                            <label for="designation">{{dynamicLabel['REPORTER_DESIGNATION'].fieldName}}</label>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_DESIGNATION'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_DESIGNATION'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <input id="designation" class="input-filed-continers" type="text"
                            [(ngModel)]="ccData.reporterDesignation">
                    </div>
                    <div class="col-md-3">
                        <div>
                            <!-- Email -->
                            <label id="email-validation" for="email">{{dynamicLabel['EMAIL_ADDRESS'].fieldName}}</label>
                            <span class="info-icon" *ngIf="dynamicLabel['EMAIL_ADDRESS'].fieldNotes"
                                [matTooltip]="dynamicLabel['EMAIL_ADDRESS'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <input id="email" class="input-filed-continers" style="width: 100%;" type="email"
                            [(ngModel)]="ccData.emailAddress" [matTooltip]="ccData.emailAddress">
                    </div>
                    <div class="col-md-3" *ngIf="dynamicLabel['REPORTER_FAX'].isRemovable != 'Y'">
                        <div>
                            <!-- Fax -->
                            <label for="fax">{{dynamicLabel['REPORTER_FAX'].fieldName}}</label>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_FAX'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_FAX'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <input id="fax" class="input-filed-continers" type="text" [(ngModel)]="ccData.reporterFax">
                    </div>
                    <div class="col-md-3">
                        <div>
                            <!-- Contact No -->
                            <label for="contact-no">{{dynamicLabel['REPORTER_CONTACT_NUMBER'].fieldName}}</label>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_CONTACT_NUMBER'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_CONTACT_NUMBER'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <input id="contact-no" class="input-filed-continers" type="number"
                            [(ngModel)]="ccData.reporterContactNumber" min="0"
                            (keypress)="validateMobileNumber($event)">
                    </div>
                    <div class="col-md-3" *ngIf="dynamicLabel['REPORTER_ADDRESS2'].isRemovable != 'Y'">
                        <div>
                            <!-- Office Contact No -->
                            <label
                                for="contact-no-off">{{dynamicLabel['REPORTER_CONTACT_NUMBER_OFFICE'].fieldName}}</label>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_CONTACT_NUMBER_OFFICE'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_CONTACT_NUMBER_OFFICE'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <input id="contact-no-off" class="input-filed-continers" type="number"
                            [(ngModel)]="ccData.reporterContactNumberOffice" min="0"
                            (keypress)="validateMobileNumber($event)">
                    </div>
                    <div class="col-md-6">
                        <div>
                            <!-- Address Field 1 -->
                            <label id="address-field1-validation" for="address-field1">
                                {{dynamicLabel['REPORTER_ADDRESS1'].fieldName}}
                            </label>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_ADDRESS1'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_ADDRESS1'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <textarea id="reporterAddress1" type="text" class="input-filed-textarea" rows="4" cols="50"
                            [(ngModel)]="ccData.reporterAddress1" (input)="validateAddress($event)"></textarea>
                    </div>
                    <div class="col-md-6" [hidden]="dynamicLabel['REPORTER_ADDRESS2'].isRemovable == 'Y'">
                        <div>
                            <!-- Address Field 2 -->
                            <label id="address-field2-validation" for="address-field2">
                                {{dynamicLabel['REPORTER_ADDRESS2'].fieldName}}
                            </label>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_ADDRESS2'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_ADDRESS2'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <textarea id="reporterAddress2" type="text" class="input-filed-textarea" rows="4" cols="50"
                            [(ngModel)]="ccData.reporterAddress2" (input)="validateAddress($event)"></textarea>
                    </div>
                    <div class="col-md-3">
                        <div>
                            <!-- City -->
                            <label for="city">{{dynamicLabel['REPORTER_CITY'].fieldName}}</label>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_CITY'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_CITY'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <input class="input-filed-continers" type="text" [(ngModel)]="ccData.reporterCity">
                    </div>
                    <div class="col-md-3">
                        <div>
                            <!-- State -->
                            <label for="state">{{dynamicLabel['REPORTER_STATE'].fieldName}}</label>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_STATE'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_STATE'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <input class="input-filed-continers" type="text" [(ngModel)]="ccData.reporterState">
                    </div>
                    <div class="col-md-3" *ngIf="dynamicLabel['REPORTER_COUNTRY'].isRemovable != 'Y'">
                        <div>
                            <!-- Country -->
                            <label for="country">{{dynamicLabel['REPORTER_COUNTRY'].fieldName}}</label>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_COUNTRY'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_COUNTRY'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReporterCountry"
                            (closed)="reporterCountrySearchText=''" (click)="focusSearch('focus-country-search')"
                            (keydown.enter)="focusSearch('focus-country-search')">
                            <input type="search" id="focus-country-search" class="dropdownsearchstyle"
                                [(ngModel)]="reporterCountrySearchText" matInput placeholder="search">
                            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                            <mat-option
                                *ngFor="let item of reporterCountryDropDown | assessmentSearch : reporterCountrySearchText"
                                [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-md-3">
                        <div>
                            <!-- Zip Code -->
                            <label for="zip-code">{{dynamicLabel['REPORTER_ZIPCODE'].fieldName}}</label>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_ZIPCODE'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_ZIPCODE'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <input class="input-filed-continers" type="text" [(ngModel)]="ccData.reporterZipcode" min="0">
                    </div>
                    <div class="col-md-6">
                        <div>
                            <!-- Reporter Type -->
                            <label id="comments" for="comments">
                                {{dynamicLabel['REPORTER_COMMENTS'].fieldName}}
                            </label> <span class="mandatory-symbol">*</span>
                            <span class="info-icon" *ngIf="dynamicLabel['REPORTER_COMMENTS'].fieldNotes"
                                [matTooltip]="dynamicLabel['REPORTER_COMMENTS'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <div class="row">
                            <div class="hideToolbar col-sm-11">
                                <st-editor [(ngModel)]="ccData.reporterComments" [config]="config" [spellcheck]="true"
                                    (paste)="onPaste($event)"
                                    (ngModelChange)="onNgModuleChange($event,'comments')"></st-editor>
                            </div>
                            <div class="col-sm-1 angular-editor-edit">
                                <i class="far fa-edit" (click)="openEditor('Reporter Comments')"
                                    (keydown.enter)="openEditor('Reporter Comments')"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3"
                        *ngIf="selectedCcGroup && qmsService.selectedGroupDetailData?.isRiskCalculationReqd == 'Y'">
                        <!-- Is Risk Calculation Reqd? -->
                        <div><label for="risk-reqd">{{dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}</label>
                            <span class="info-icon" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"
                                [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes">
                                <img [src]="infoIconSrc" alt="note" width="18" height="18">
                            </span>
                        </div>
                        <mat-slide-toggle color="primary" [(ngModel)]="ccData.isRiskCalculationReqd">
                            <ng-container *ngIf="ccData.isRiskCalculationReqd; else no">
                                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                            </ng-container>
                            <ng-template #no>
                                <span style="color: red;">No</span>
                            </ng-template>
                        </mat-slide-toggle>
                    </div>
                    <div *ngIf="!message.showComplaintSwitch">
                        <app-flexible-fields #flexible [from]="'Master'"></app-flexible-fields>
                    </div>
                </div>
                <div class="row field-style">
                    <div class="button-continer btn-align" mat-dialog-actions>
                        <button mat-stroked-button class="addButton" (click)="save(ccData)">
                            <i class="fas fa-check"></i> Raise Complaint
                        </button>
                        <button *ngIf="!message.showComplaintSwitch" mat-stroked-button class="cancelButton"
                            (click)="cancel()">
                            <i class="fa fa-close"></i> Cancel
                        </button>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>

    <div *ngIf="visibleComplaintGrid">
        <div class="position-relative grid-content">
            <div>
                <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center px-3">
                        <div class="dropdown">
                        </div>
                    </div>
                    <div class="d-flex gap-3">
                        <div id="header-container">
                            <div class="">
                                <div class="search-container">
                                    <span class="fa fa-search form-control-feedback"></span>
                                    <input type="text" class="form-control search_input" style="font-size: 12px"
                                        placeholder="Search here..." [(ngModel)]="searchValue"
                                        (input)="applyFilter2($event)" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-container">
                <table class="dynamic-table-container" aria-describedby="table-description">
                    <th style="min-width: 60px; text-align: center;"
                        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                        <div style="display: flex;">
                            <div>
                                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                        </div>
                    </th>
                    <th id="grid-header-container" (focus)="focusEmpty()"
                        *ngFor="let columnData of columnLists.fieldColumnarray; let ix = index;" [ngStyle]="{'min-width': columnData.width,'max-width': columnData.width,'overflow': 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssfunction(0)">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                            <span>{{ columnData.fieldColumnarray }}</span>
                            <div class="d-flex gap-2 align-items-center">
                                <div class="sort" (click)="sortColumn(columnLists.columnsListarray[ix],columnData)"
                                    (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],columnData)">
                                    <div><i *ngIf="sortedDisplayColumn==columnData.fieldColumnarray && sortDirection=='asc'"
                                            class='fas fa-angle-up' style='font-size:11px'></i></div>
                                    <div><i *ngIf="sortedDisplayColumn==columnData.fieldColumnarray && sortDirection=='desc'"
                                            class='fas fa-angle-down' style='font-size:11px'></i></div>
                                    <img *ngIf="sortedDisplayColumn!=columnData.fieldColumnarray"
                                        src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
                                        alt="sort" />
                                </div>
                            </div>
                        </div>
                    </th>
                    <th id="menu" class="sticky-col first-col"></th>
                    <tr>
                        <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
                        <td *ngFor=" let columnData of columnLists.fieldColumnarray; let ix = index "
                            [ngStyle]="{ 'min-width': columnData.width != null ? columnData.width : '200px' }"
                            class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
                            <div class="row-search-container"><input type="text" class="form-control"
                                    placeholder="Search"
                                    (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" /> </div>
                        </td>
                    </tr>
                    <tr *ngFor="let list of pagedItems let idx = index;">
                        <td style="min-width: 60px; text-align: center;"
                            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                            <div style="display: flex;">
                                <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                                <div>
                                    <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                                        (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                                </div>
                            </div>
                        </td>
                        <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                            (focus)="focusEmpty()" class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
                    'text-overflow': 'ellipsis',
                    'white-space': 'nowrap'}" (mouseover)="cssfunction(i)" (click)="detailsData(list, false,$event,i)"
                            (keydown.enter)="detailsData(list, false,$event,i)">
                            <span *ngIf="key.dataType=='CHECKBOX'">
                                <div class="gridCheckBoxes">
                                    <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg"
                                        alt="Yes" width="20" height="20">
                                    <img *ngIf="list[key.columnsListarray]==false"
                                        src="../../assets/img/noAcessSymbol.svg" alt="No" width="20" height="20">
                                </div>
                            </span>

                            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
                                <div class="download-button-continer btn-align" mat-dialog-actions>
                                    <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                                        (click)="getClobData(list,key.columnsListarray)">
                                        <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px"
                                            alt="download">
                                        <span class="ms-1">View</span>
                                    </button>
                                </div>
                            </span>

                            <span
                                *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] != 'htmlClobView'">{{
                                list[key.columnsListarray]
                                }}</span>
                            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
                        </td>
                    </tr>
                </table>
                <div class="d-flex justify-content-center">
                    <div class="width-cheat small paginationCell">
                        <div class="d-flex align-items-center gap-3">
                            <div class="pagination_text mt-3">
                                {{ showingRowsText }}
                                1-{{ perPage }} of {{ collectionSize | number }}
                            </div>
                            <div>
                                <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)"
                                    [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                                    [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                                    [boundaryLinks]="true" size="sm">
                                </ngb-pagination>
                            </div>
                            <div ngbDropdown class="mt-3">
                                <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                                    ngbDropdownToggle>
                                    {{ perPage }}
                                    <i class="ms-1 fa-solid fa-chevron-down"></i>
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                    <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                                    <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                                    <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                                </div>
                                per page
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #angularEditorTextarea>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAngularEditorData()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ this.textareaEditorTitle }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="row"></div>
            <div class="col-sm-12"><st-editor [(ngModel)]="editorValue" [config]="config1" [spellcheck]="true"
                    (paste)="onPaste($event)"></st-editor>
            </div>
        </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="okAngularEditorData(editorValue)">
            <i class="fas fa-check"></i> Save
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelAngularEditorData()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #mandatoryPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>

    <button class="close close-button" (click)="closeMandatoryPopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Mandatory Alert </label>
    </div>

    <div style="margin: 15px 15px;">
        <div style="display: flex; justify-content: center; align-items: center;">
            <span style="font-weight: 500; font-size: larger;"> Please enter all Mandatory Fields
                <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
            </span>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="cancelButton" (click)="closeMandatoryPopup()">
                Ok
            </button>
        </div>
    </div>
</ng-template>

<app-editor #clobViewPopup></app-editor>